import React, { useState, useEffect, useRef } from "react";
import Loadingimg from "../components_root/loadingimg";
import Loading from "../components_root/loading";

export default function MediaViewer({ product_filedata, isLoading, logo_default }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState(null);
  const [autoPlay, setAutoPlay] = useState(true); // 🚀 autoplay ON by default
  const intervalRef = useRef(null);

  // 🔄 Auto slide effect
  useEffect(() => {
    if (autoPlay && product_filedata.length > 1) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) =>
          prev < product_filedata.length - 1 ? prev + 1 : 0
        );
      }, 5000); // change every 3s
    }
    return () => clearInterval(intervalRef.current);
  }, [autoPlay, product_filedata]);

  // 🖐️ Common function to handle swipe
  const handleSwipe = (endX) => {
    if (startX === null) return;
    const diff = startX - endX;

    if (diff > 50) {
      // Swipe Left → Next
      setCurrentIndex((prev) =>
        prev < product_filedata.length - 1 ? prev + 1 : 0
      );
    } else if (diff < -50) {
      // Swipe Right → Previous
      setCurrentIndex((prev) =>
        prev > 0 ? prev - 1 : product_filedata.length - 1
      );
    }
    //setStartX(null);
    setAutoPlay(false); // ❌ Stop auto when user swipes
  };

  // 🖱️ When clicking thumbnail → stop autoplay
  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
    setAutoPlay(false); // ❌ Stop auto when user clicks
  };

  return (
    <div className="media_view">
      {/* Main Image with Swipe Support */}
      <div
        className="m-top"
        onTouchStart={(e) => setStartX(e.touches[0].clientX)}
        onTouchEnd={(e) => handleSwipe(e.changedTouches[0].clientX)}
        onMouseDown={(e) => setStartX(e.clientX)}
        onMouseUp={(e) => handleSwipe(e.clientX)}
      >
        {isLoading ? (
          <Loadingimg />
        ) : (
          <img
            className="media_select_size"
            src={product_filedata[currentIndex]?.url || logo_default}
            alt="Selected"
          />
        )}
      </div>

      {/* Thumbnail Grid */}
      <div className="ui-grid-media" style={{marginTop:"5px"}}>
        {isLoading ? (
          <Loadingimg />
        ) : product_filedata.length === 0 ? (
          <div>No files found</div>
        ) : (
          product_filedata.map((row, index) => (
            <div className="ui-items-media" key={index}>
              <img
                onClick={() => handleThumbnailClick(index)}
                className={`media_size ${
                  currentIndex === index ? "active" : ""
                }`}
                src={row.url || logo_default}
                alt={`file-${index}`}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
